import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/shared/services/storage/storage.service';
import { Subject } from 'rxjs';
import jwt_decode from 'jwt-decode';

@Injectable()
export class JwtService {
  private _onToken = new Subject();
  onToken = this._onToken.asObservable();

  constructor(private storageService: StorageService) {}

  async getToken(): Promise<any> {
    const resp = await this.storageService?.get('token');
    return resp;
  }

  async saveToken(token: String) {
    this._onToken.next('tokenSet');
    return await this.storageService.set('token', token);
  }

  async destroyToken() {
    this._onToken.next('tokenDeleted');
    return await this.storageService.clear();
  }

  getJWTDecodeToken(){
    let decodeTokenValue = {
      clientId: 0,
      arName: '',
      ar_client_id:0
    }
    this.getToken().then((response) => {
      if (response) {
        var decoded: any = jwt_decode(response);
         decodeTokenValue = {
          clientId: decoded.client_id,
          arName: decoded.client_name,
          ar_client_id: decoded.ar_client_id
        }
      }
    })

    return decodeTokenValue;
  }
}
